/*!
 * KoliBri - The accessible HTML-Standard
 */
import { h, H as Host, r as registerInstance, g as getElement } from './index-C_ZKddLG.js';
import { _ as __decorate } from './tslib.es6-QNbPBOk5.js';
import { b as watchValidator, g as watchString, e as watchBoolean, S as mapStringOrBoolean2String, U as mapBoolean2String, t as setEventTarget, X, s as setState } from './common-D-vggmh2.js';
import { S as SpanFC, s as showExpertSlot } from './component-DepnuZGT.js';
import { A as AssociatedInputController, v as validateAccessKey, a as validateShortKey, b as validateTabIndex } from './associated.controller-FCQDejnI.js';
import { v as validateCustomClass } from './custom-class-BtoZpwyq.js';
import { v as validateDisabled } from './disabled-CL52u2mm.js';
import { v as validateHideLabel } from './hide-label-CRGm6KGP.js';
import { v as validateIcons } from './icons-mXXqyviE.js';
import { v as validateInline } from './inline-DCDQA_d_.js';
import { a as validateLabelWithExpertSlot } from './label-w3T7Y2ih.js';
import { v as validateTooltipAlign } from './tooltip-align-BQmLWbBy.js';
import { c as classNameFromVariant, v as validateVariantClassName } from './variant-class-name-9qZ5egaq.js';
import { B as BaseWebComponent } from './base-web-component-D909Fl-Y.js';
import { T as TooltipBehavior } from './behavior-Co00uT-D.js';
import { T as TooltipFC } from './component-BXCnkVUN.js';
import { v as validateAccessAndShortKey } from './access-and-short-key-ijzCZfHm.js';
import { c as clsx } from './clsx-COFh-Vc8.js';
import { n as nonce } from './dev.utils-Cib2ENyx.js';
import { b as directFocus, e as directClick, c as createCtaRef } from './element-interaction-C5-6aPzz.js';
import { d as dispatchDomEvent, K as KolEvent } from './events-BhfZTW2e.js';
import { p as propagateSubmitEventToForm, a as propagateResetEventToForm } from './controller-D__mtOju.js';
import './bem-registry-3ondDImf.js';
import './component-BjVFpeYY.js';
import './isArray-CcrBs4JM.js';
import './aria-details-hRfn8aN9.js';
import './aria-labelledby-6-ki3akM.js';
import './bootstrap-Bfno1qh2.js';
import './component-names-DwvrfFak.js';
import './i18n-C73LqPIs.js';
import './align-C8fl12z_.js';
import './align-floating-elements-CBhVmYjn.js';
import './tooltip-open-tracking-D3tCiiGP.js';
import './normalizers-BNeak4hj.js';
import './_Uint8Array-kJHDjtoP.js';
import './label-FtX-skKy.js';
import './variant-quote-ClYWonZq.js';
import './element-focus-BQXzaLL9.js';

const alternativeButtonLinkRolePropTypeOptions = ['tab', 'treeitem'];
const validateAlternativeButtonLinkRole = (component, value) => {
    watchValidator(component, `_role`, (value) => typeof value === 'string' && alternativeButtonLinkRolePropTypeOptions.includes(value), new Set([`KoliBriAlternativeButtonLinkRole {${alternativeButtonLinkRolePropTypeOptions.join(', ')}`]), value);
};

const validateAriaControls = (component, value) => {
    watchString(component, '_ariaControls', value);
};

const validateAriaDescription = (component, value) => {
    watchString(component, '_ariaDescription', value);
};

const validateAriaExpanded = (component, value) => {
    watchBoolean(component, '_ariaExpanded', value);
};

const validateAriaSelected = (component, value) => {
    watchBoolean(component, '_ariaSelected', value);
};

const validateButtonCallbacks = (component, value) => {
    watchValidator(component, `_on`, (value) => typeof value === 'object' && value !== null, new Set(['ButtonCallbacksPropType {Events.onClick, Events.onMouseDown, Events.onFocus, Events.onBlur}']), value);
};

const buttonTypePropTypeOptions = ['button', 'reset', 'submit'];
const validateButtonType = (component, value) => {
    watchValidator(component, `_type`, (value) => typeof value === 'string' && buttonTypePropTypeOptions.includes(value), new Set([`KoliBriButtonType {${buttonTypePropTypeOptions.join(', ')}`]), value);
};

const KolButtonWc = class {
    async focus(options) { }
    async click() { }
    render() {
        var _a, _b;
        const hasExpertSlot = showExpertSlot(this.state._label);
        const hasAriaDescription = Boolean((_b = (_a = this.state._ariaDescription) === null || _a === void 0 ? void 0 : _a.trim()) === null || _b === void 0 ? void 0 : _b.length);
        const badgeText = this.state._accessKey || this.state._shortKey;
        const isDisabled = this.state._disabled === true;
        const hideLabel = this.state._hideLabel === true;
        return (h(Host, { key: '221d588a96d3380606377705e11c6dea182e24e5' }, h("button", { key: '76e287935dd7f2c54875d5ed46bfeaeae34cff19', ref: this.ctaRef, accessKey: this.state._accessKey, "aria-controls": this.state._ariaControls, "aria-describedby": hasAriaDescription ? this.internalDescriptionById : undefined, "aria-expanded": mapBoolean2String(this.state._ariaExpanded), "aria-haspopup": this._ariaHasPopup, "aria-keyshortcuts": this.state._shortKey, "aria-label": hideLabel && typeof this.state._label === 'string' && this.state._label.length > 0 ? this.state._label : undefined, "aria-selected": mapStringOrBoolean2String(this.state._ariaSelected), class: clsx('kol-button', {
                'kol-button--disabled': isDisabled,
                [classNameFromVariant(this.state._variant, 'button')]: this.state._variant !== undefined,
                'kol-button--inline': this.state._inline === true,
                'kol-button--standalone': this.state._inline === false,
                'kol-button--hide-label': hideLabel,
                [this.state._customClass]: typeof this.state._customClass === 'string' && this.state._customClass.length > 0,
            }), disabled: isDisabled, id: this.state._id, name: this.state._name, onClick: this.onClick, onMouseDown: this.onMouseDown, onFocus: this.onFocus, onBlur: this.onBlur, role: this.state._role, tabIndex: this.state._tabIndex, type: this.state._type }, h(SpanFC, { key: 'a952ebc2063044a81f1bee81338a6b6c27e8ec86', class: "kol-button__text", badgeText: badgeText, icons: this.state._icons, hideLabel: hideLabel, label: hasExpertSlot ? '' : this.state._label }, h("slot", { key: '9495e37f98b7155172ceb6b639fd95d2291a0a86', name: "expert", slot: "expert" }))), hideLabel && typeof this.state._label === 'string' && this.state._label.length > 0 && (h("div", { key: '662387306af9583fab64d6f59c723ed44ce13019', class: "kol-button__tooltip" }, h(TooltipFC, { key: '743b4b515f88437df7e1080e8c3aa49b0befd85c', badgeText: badgeText || '', label: this.state._label, id: this.tooltipBehavior.getRenderProp('id'), refFloating: this.tooltipBehavior.setTooltipElementRef }))), hasAriaDescription && (h("span", { key: '47e8746efa42af91a209a9a9999b1ea42b4fe617', class: "visually-hidden", id: this.internalDescriptionById }, this.state._ariaDescription))));
    }
    constructor(hostRef) {
        registerInstance(this, hostRef);
        var _a;
        this.ctaRef = createCtaRef();
        this.tooltipBehavior = new TooltipBehavior(BaseWebComponent.stateLess);
        this.internalDescriptionById = nonce();
        this.onClick = (event) => {
            var _a, _b;
            event.stopPropagation();
            this.tooltipBehavior.hideTooltip();
            if (this.state._type === 'submit') {
                propagateSubmitEventToForm({
                    form: this.host});
            }
            else if (this.state._type === 'reset') {
                propagateResetEventToForm({
                    form: this.host});
            }
            else {
                this.controller.setFormAssociatedValue(this.state._value);
                if (typeof ((_a = this.state._on) === null || _a === void 0 ? void 0 : _a.onClick) === 'function') {
                    setEventTarget(event, this.ctaRef.el);
                    (_b = this.state._on) === null || _b === void 0 ? void 0 : _b.onClick(event, this.state._value);
                }
            }
            if (this.host) {
                dispatchDomEvent(this.host, KolEvent.click, this.state._value);
            }
        };
        this.onMouseDown = (event) => {
            var _a, _b, _c;
            (_c = (_b = (_a = this.state) === null || _a === void 0 ? void 0 : _a._on) === null || _b === void 0 ? void 0 : _b.onMouseDown) === null || _c === void 0 ? void 0 : _c.call(_b, event);
            if (this.host) {
                dispatchDomEvent(this.host, KolEvent.mousedown);
            }
        };
        this.onFocus = (event) => {
            var _a, _b, _c;
            (_c = (_b = (_a = this.state) === null || _a === void 0 ? void 0 : _a._on) === null || _b === void 0 ? void 0 : _b.onFocus) === null || _c === void 0 ? void 0 : _c.call(_b, event);
            if (this.host) {
                dispatchDomEvent(this.host, KolEvent.focus);
            }
        };
        this.onBlur = (event) => {
            var _a, _b, _c;
            (_c = (_b = (_a = this.state) === null || _a === void 0 ? void 0 : _a._on) === null || _b === void 0 ? void 0 : _b.onBlur) === null || _c === void 0 ? void 0 : _c.call(_b, event);
            if (this.host) {
                dispatchDomEvent(this.host, KolEvent.blur);
            }
        };
        this._disabled = false;
        this._hideLabel = false;
        this._inline = false;
        this._tooltipAlign = 'top';
        this._type = 'button';
        this._variant = (_a = X('buttonVariantDefault', this.host)) !== null && _a !== void 0 ? _a : 'normal';
        this.state = {
            _icons: {},
            _label: '',
            _on: {},
            _type: 'button',
        };
        this.controller = new AssociatedInputController(this, 'button', this.host);
    }
    validateAccessKey(value) {
        validateAccessKey(this, value);
        validateAccessAndShortKey(value, this._shortKey);
    }
    validateAriaControls(value) {
        validateAriaControls(this, value);
    }
    validateAriaDescription(value) {
        validateAriaDescription(this, value);
    }
    validateAriaExpanded(value) {
        validateAriaExpanded(this, value);
    }
    validateAriaSelected(value) {
        validateAriaSelected(this, value);
    }
    validateCustomClass(value) {
        validateCustomClass(this, value);
    }
    validateDisabled(value) {
        validateDisabled(this, value);
    }
    validateHideLabel(value) {
        validateHideLabel(this, value);
    }
    validateIcons(value) {
        validateIcons(this, value);
    }
    validateId(value) {
        watchString(this, '_id', value);
    }
    validateInline(value) {
        validateInline(this, value, {
            defaultValue: false,
        });
    }
    validateLabel(value) {
        validateLabelWithExpertSlot(this, value, {
            required: true,
        });
        this.tooltipBehavior.watchLabel(typeof value === 'string' ? value : undefined);
    }
    validateName(value) {
        this.controller.validateName(value);
    }
    validateOn(value) {
        validateButtonCallbacks(this, value);
    }
    validateRole(value) {
        validateAlternativeButtonLinkRole(this, value);
    }
    validateShortKey(value) {
        validateShortKey(this, value);
        validateAccessAndShortKey(this._accessKey, value);
    }
    validateSyncValueBySelector(value) {
        this.controller.validateSyncValueBySelector(value);
    }
    validateTabIndex(value) {
        validateTabIndex(this, value);
    }
    validateTooltipAlign(value) {
        validateTooltipAlign(this, value);
        this.tooltipBehavior.watchAlign(value);
    }
    validateType(value) {
        validateButtonType(this, value);
    }
    validateValue(value) {
        setState(this, '_value', value);
        this.controller.setFormAssociatedValue(this.state._value);
    }
    validateVariant(value) {
        validateVariantClassName(this, value);
    }
    componentWillLoad() {
        this.validateAccessKey(this._accessKey);
        this.validateAriaControls(this._ariaControls);
        this.validateAriaDescription(this._ariaDescription);
        this.validateAriaExpanded(this._ariaExpanded);
        this.validateAriaSelected(this._ariaSelected);
        this.validateCustomClass(this._customClass);
        this.validateDisabled(this._disabled);
        this.validateHideLabel(this._hideLabel);
        this.validateIcons(this._icons);
        this.validateId(this._id);
        this.validateInline(this._inline);
        this.validateLabel(this._label);
        this.validateName(this._name);
        this.validateOn(this._on);
        this.validateRole(this._role);
        this.validateShortKey(this._shortKey);
        this.validateSyncValueBySelector(this._syncValueBySelector);
        this.validateTabIndex(this._tabIndex);
        this.validateTooltipAlign(this._tooltipAlign);
        this.validateType(this._type);
        this.validateValue(this._value);
        this.validateVariant(this._variant);
        validateAccessAndShortKey(this._accessKey, this._shortKey);
        this.tooltipBehavior.componentWillLoad({
            label: typeof this.state._label === 'string' ? this.state._label : '',
            align: this._tooltipAlign,
        });
    }
    componentDidRender() {
        if (this.ctaRef.el) {
            this.tooltipBehavior.syncListeners(undefined, this.ctaRef.el, true);
        }
    }
    disconnectedCallback() {
        this.tooltipBehavior.destroy();
    }
    get host() { return getElement(this); }
    static get watchers() { return {
        "_accessKey": ["validateAccessKey"],
        "_ariaControls": ["validateAriaControls"],
        "_ariaDescription": ["validateAriaDescription"],
        "_ariaExpanded": ["validateAriaExpanded"],
        "_ariaSelected": ["validateAriaSelected"],
        "_customClass": ["validateCustomClass"],
        "_disabled": ["validateDisabled"],
        "_hideLabel": ["validateHideLabel"],
        "_icons": ["validateIcons"],
        "_id": ["validateId"],
        "_inline": ["validateInline"],
        "_label": ["validateLabel"],
        "_name": ["validateName"],
        "_on": ["validateOn"],
        "_role": ["validateRole"],
        "_shortKey": ["validateShortKey"],
        "_syncValueBySelector": ["validateSyncValueBySelector"],
        "_tabIndex": ["validateTabIndex"],
        "_tooltipAlign": ["validateTooltipAlign"],
        "_type": ["validateType"],
        "_value": ["validateValue"],
        "_variant": ["validateVariant"]
    }; }
};
__decorate([
    directFocus('ctaRef')
], KolButtonWc.prototype, "focus", null);
__decorate([
    directClick('ctaRef')
], KolButtonWc.prototype, "click", null);

export { KolButtonWc as kol_button_wc };
//# sourceMappingURL=kol-button-wc.entry.js.map
